export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      tempSelectedOptions: [],
    }
  },

  computed: {
    haveSelectedOptions() {
      return this.value.length > 0
    },
  },

  watch: {
    value: {
      handler(value) {
        this.tempSelectedOptions = [...value];
      },
      immediate: true,
    },
  },

  methods: {
    applyFilter() {
      this.$emit('apply',{ id: this.name, value: [...this.tempSelectedOptions] });
    },
    addOption(addedOption) {
      if(addedOption.count === 0) {
        return;
      }

      this.tempSelectedOptions.push(Object.assign({}, addedOption));
    },
    removeOption(removedOption) {
      const indexToRemove = this.tempSelectedOptions.findIndex(({ value }) => removedOption.value === value);

      this.tempSelectedOptions.splice(indexToRemove, 1);
    },
    localClear() {
      this.tempSelectedOptions = [];
    },
    clear() {
      this.localClear();
      this.$emit('clear', this.name);
    },
  }
}